import { DOCUMENT } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  DestroyRef,
  OnInit,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { installGlobalImageFallback } from './shared/utils/image-fallback.util';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: ` <router-outlet></router-outlet> `,
})
export class AppComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly doc = inject(DOCUMENT);

  ngOnInit(): void {
    initFlowbite();
    const uninstallImageFallback = installGlobalImageFallback(this.doc);
    this.destroyRef.onDestroy(uninstallImageFallback);
  }
}
